export const getCookieValue = (key: string) => {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find(cookie => cookie.includes(`${key}=`));
  if (!cookie) {
    return undefined;
  }
  const cookieValue = cookie.split('=')[1];
  return cookieValue;
};
